
import { ColumnWidth } from '@vfde-fe/ngx-lib/brix/ws10-grid';
import { FormSelectItemState } from '@vfde-fe/ngx-lib/brix/ws10-form-select';
/** VLUXGATE_ENVIROMENT */
export const VLUXGATE_ENVIROMENT = 'vluxgateSIT';

/** LOGIN_URL */
export const LOGIN_URL = {
    url: '/meinvodafone/account/login',
};
/** LOGOUT_URL */
export const LOGOUT_URL = {
    url: '/mint/saml/logout',
};
/** TARGET_URL */
export const TARGET_URL = 'targetURL';

/** WORDING_FILES */
export const WORDING_FILES = {
    defaultWording: 'defaultWording',
    deWording: 'deWording',
};

/** Ignore_General_Error */
export const Ignore_General_Error = 'skip-general-error';

/** Stop_Failure_Tracking */
export const Stop_Failure_Tracking = 'stop-failure-tracking';

/** Ignore_Tracking if you want the interceptor to ignore tracking error */
export const Ignore_Tracking = 'ignore-tracking';

/** simSwapAccordion */
export const simSwapAccordion = '/teilnehmer/sim-karte-einstellungen?accordion=ihre-sim-karte';

/** PENDING_ESIM_SWAPPING_ERROR */
export const PENDING_ESIM_SWAPPING_ERROR = 'NIL0F0458';

/** API_KEY_HEADERS_FORMCENTER_PROD */
export const API_KEY_HEADERS_FORMCENTER_PROD = '2mPLbrEtIUPWTtUIllrUDtnyk4g0IxgC';
/** API_KEY_HEADERS_FORMCENTER_PREPROD */
export const API_KEY_HEADERS_FORMCENTER_PREPROD = 'CwcWV5Jvb7N3aQe4zCO1SA6usS0Ii9mP';
/** FORM_CENTER_LIMIT_NUMBER */
export const FORM_CENTER_LIMIT_NUMBER = '7';
/** GIRD_SYSTEM_FORM_CENTER */
export const GIRD_SYSTEM_FORM_CENTER = [
  {width: 1},
  {withMultiBreakpoints: true, width: 12},
  { withMultiBreakpoints: true, width: 12, widthLarge: 3, widthXLarge: 3, widthSmall: 12, widthMedium: 12},
  { withMultiBreakpoints: true, width: 12, widthLarge: 6, widthXLarge: 6,  widthSmall: 12, widthMedium: 9 },
  { withMultiBreakpoints: true, width: 12, widthLarge: 9, widthXLarge: 9, widthSmall: 12, widthMedium: 12 },
  { withMultiBreakpoints: true, width: 1, widthLarge: 4, widthXLarge: 4, widthSmall: 1, widthMedium: 1},
  { withMultiBreakpoints: true, width: 10, widthLarge: 4, widthXLarge: 4, widthSmall: 10, widthMedium: 10 },

];

/** TARGET */
export const TARGET = {
  BLANK: '_blank',
  SELF: '_self',
};

/** DOWNLOAD_ICON */
export const DOWNLOAD_ICON = 'download-ws10-red';

/** COLOR_VARIANT */
export const COLOR_VARIANT = 'color-primary-200';

/** SUCCESS_ICON */
export const SUCCESS_ICON = 'success-red';
/** PARAGRAPH_SIZE */
export const PARAGRAPH_SIZE = 'normal';

/** FORM_EDITOR_GRID_COLUMN */
export const FORM_EDITOR_GRID_COLUMN = {
  withMultiBreakpoints: true,
  width: 12 as ColumnWidth,
  widthMedium: 7 as ColumnWidth,
  widthLarge: 4 as ColumnWidth,
  widthXLarge: 4 as ColumnWidth,
};

/** SELECTED */
export const SELECTED = 'selected' as FormSelectItemState;


/** fileUpload check */
export const CHECK_FILE_UPLOAD_MANDATORY = 'mandatory';
/** CHECK_FILE_UPLOAD_OPTIONAL */
export const CHECK_FILE_UPLOAD_OPTIONAL = 'optional';
/** FILE_FIELD_KEY  */
export const FILE_FIELD_KEY  = 'file';
